import React, { ReactElement } from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

export function FdrSharePdfOverlaySkeleton(): ReactElement {
  const { mobile } = useDeviceType();

  return (
    <div data-id="FdrSharePdfOverlaySkeleton">
      <PlaceholderLoader
        uid="FdrSharePdfOverlaySkeleton"
        width={mobile ? 318 : 558}
        height={mobile ? 86 : 103}
        viewBox={mobile ? '0 0 318 86' : '0 0 558 103'}
      >
        {mobile ? (
          <>
            <rect width="161" height="37" rx="4" fill="#D9D9D9" />
            <rect x="123" y="49" width="195" height="37" rx="4" />
            <rect x="174" width="37" height="37" rx="4" />
            <rect x="281" width="37" height="37" rx="4" />
            <rect x="227" width="37" height="37" rx="4" />
          </>
        ) : (
          <>
            <rect width="384" height="40" rx="4" />
            <rect x="347" y="63" width="211" height="40" rx="4" />
            <rect x="402" width="40" height="40" rx="4" />
            <rect x="518" width="40" height="40" rx="4" />
            <rect x="460" width="40" height="40" rx="4" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
}
